<div class="primary">
  <ng-content select="rt-toolbar-primary" />
</div>
<div class="secondary">
  <ng-content select="rt-toolbar-secondary" />
</div>
